import React from 'react';
import { Link } from 'react-router-dom';
import { Col } from 'react-bootstrap';

import HeaderNav from './HeaderNav/HeaderNav';
import UserNav from './UserNav/UserNav';

function Header() {
    return (
        <header id="header">
            <div className="container d-flex">
                <Col md={2} lg={3} className="pl-0">
                    <div id="logo">
                        <Link to="/">Eventos</Link>
                    </div>
                </Col>
                <Col md={8} lg={6}>
                    <HeaderNav />
                </Col>
                <Col className="pr-0 d-flex justify-content-end" md={2} lg={3}>
                    <UserNav />
                </Col>
            </div>
        </header>
    );
}

export default Header;